import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const getWalkthroughSuites = (_, { payload }) => {
    return [
        ...payload,
    ]
  };

  const initialState = [];

  export default createReducer(initialState, {
    [TYPES.GET_WALK_THROUGH_SUITES]: getWalkthroughSuites
  });